// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InfoBanner_banner__KUa6u {
  padding: 10px 1rem;
  display: flex;
  gap: 0.5rem;
  align-items: center;
  border-radius: 4px;
  border-style: solid;
  border-width: 1px;
}
.InfoBanner_banner__KUa6u[data-style=error] {
  color: #721c24;
  background-color: #f8d7da;
  border-color: #f5c6cb;
}
.InfoBanner_banner__KUa6u[data-style=warning] {
  color: #856404;
  background-color: #fff3cd;
  border-color: #ffeeba;
}
.InfoBanner_banner__KUa6u[data-style=informative] {
  background-color: #e9e9e9;
  border-color: #cacaca;
}
.InfoBanner_banner__KUa6u[data-small=true] {
  gap: 8px;
  padding: 4px 8px;
}`, "",{"version":3,"sources":["webpack://./src/components/Misc/InfoBanner.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;EAEA,kBAAA;EACA,mBAAA;EACA,iBAAA;AAAF;AAEE;EACE,cAAA;EACA,yBAAA;EACA,qBAAA;AAAJ;AAGE;EACE,cAAA;EACA,yBAAA;EACA,qBAAA;AADJ;AAIE;EACE,yBAAA;EACA,qBAAA;AAFJ;AAKE;EACE,QAAA;EACA,gBAAA;AAHJ","sourcesContent":[".banner {\n  padding: 10px 1rem;\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n  border-radius: 4px;\n  border-style: solid;\n  border-width: 1px;\n}\n.banner[data-style=error] {\n  color: #721c24;\n  background-color: #f8d7da;\n  border-color: #f5c6cb;\n}\n.banner[data-style=warning] {\n  color: #856404;\n  background-color: #fff3cd;\n  border-color: #ffeeba;\n}\n.banner[data-style=informative] {\n  background-color: #e9e9e9;\n  border-color: #cacaca;\n}\n.banner[data-small=true] {\n  gap: 8px;\n  padding: 4px 8px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"banner": `InfoBanner_banner__KUa6u`
};
export default ___CSS_LOADER_EXPORT___;
